import { call, put, select, takeLatest } from 'redux-saga/effects';
import { setIsFetching, setShifts } from './actions';

import { HealAPI } from '../../healApi';
import { RootState } from '../types';
import { UIAction } from '../ui/actions';

function* handleSelectedDateChanged(): any {
  const state: RootState = yield select((s) => s);
  yield put(setIsFetching(true));
  const result = yield call(HealAPI.getShiftsForDate, state.ui.date);
  if (result.data) {
    yield put(setShifts(result.data));
  }
  yield put(setIsFetching(false));
}

export function* schedulingFlow() {
  yield takeLatest(['PAGE_DID_MOUNT/Scheduling', UIAction.SET_DATE], handleSelectedDateChanged);
}
